export default __webpack_public_path__ + "static/media/increase.b7422939.svg";